import { Text } from '@wix/design-system';
import * as React from 'react';
import css from './RecurringPayView.scss';
export const frequencyTranslations = {
    ["daily" /* BillingCycle.DAILY */]: 'invoice.recurring.email.billing-frequency.daily',
    ["weekly" /* BillingCycle.WEEKLY */]: 'invoice.recurring.email.billing-frequency.weekly',
    ["fortnightly" /* BillingCycle.FORTNIGHTLY */]: 'invoice.recurring.email.billing-frequency.fortnightly',
    ["monthly" /* BillingCycle.MONTHLY */]: 'invoice.recurring.email.billing-frequency.monthly',
    ["yearly" /* BillingCycle.YEARLY */]: 'invoice.recurring.email.billing-frequency.yearly',
};
export const RecurringPayView = ({ t, invoice, currency, }) => {
    const { total, metaData: { sourceProperties: { billingCycle, numberOfBillingCycles, frequency }, }, } = invoice;
    const isUnlimitedBilling = numberOfBillingCycles === '0';
    return (React.createElement("div", { "data-hook": "recurring-pay-view", className: css.container },
        React.createElement(Text, { weight: "bold" },
            `${t('recurring-payment-uou.title')} `,
            isUnlimitedBilling
                ? t('recurring-payment-uou.title.unlimited', { billingCycle })
                : t('recurring-payment-uou.title.limited', {
                    billingCycle,
                    numberOfBillingCycles,
                }),
            React.createElement("br", null)),
        React.createElement(Text, { size: "small" }, t('invoice.recurring.pay.view.text', {
            total: currency(total),
            frequency: t(frequencyTranslations[frequency.toLocaleLowerCase()]),
        }))));
};
//# sourceMappingURL=RecurringPayView.js.map